import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file usePrecisionValue 输入类组件
 */
import { useRefGetter } from '@tencent/glue-react-use';
import { useCallback, useEffect, useState } from 'react';
import { usePoint } from './usePoint';
export var DEFAULT_CONVERTER = function DEFAULT_CONVERTER(val) {
  return val;
}; // part和type不能变化

export function usePrecisionValue(part, type) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_CONVERTER;
  var parse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_CONVERTER;
  var point = usePoint(part);
  var formatGetter = useRefGetter(format);
  var parseGetter = useRefGetter(parse);

  var _useState = useState(function () {
    return formatGetter()(point.getPrecisionValue(type));
  }),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var valueRef = useRefGetter(value);
  var onInput = useCallback(function (val) {
    setValue(val);
    point.setPrecisionValue(type, parseGetter()(val), true);
  }, []);
  var onBlur = useCallback(function () {
    var val = parseGetter()(valueRef());

    if (point.getAxis(type).isValidPrecisionValue(val)) {
      point.setPrecisionValue(type, val);
      return;
    }

    setValue(formatGetter()(point.getPrecisionValue(type)));
  }, []);
  useEffect(function () {
    var handleRepaint = function handleRepaint() {
      setValue(formatGetter()(point.getPrecisionValue(type)));
    };

    point.addListener('repaint', handleRepaint);
    return function () {
      return point.removeListener('repaint', handleRepaint);
    };
  }, [point]);
  return [value, onInput, onBlur];
}